import { useNavigate } from 'react-router-dom';
import React, { useEffect } from "react";
import '../styles/pages/Home.css';
export default function Home() {
  const navigate = useNavigate();

  useEffect(() => {
    const io = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add("inview")),
      { threshold: 0.12 }
    );
    document.querySelectorAll(".reveal").forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  const onCardKey = (e, to) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      navigate(to);
    }
  };

  return (
    <div className="home">
      {/* HERO */}
      <section className="hero" aria-label="Hero video">
        <img className="hero-media" src="/images/event.jpg" alt='Event'>
        </img>

        <div className="hero-overlay" />
        <div className="hero-content">
          <h1>Poznawaj ludzi offline</h1>
          <h2 className="main-h2">Tworzymy wydarzenia, które łączą</h2>
          <div className="hero-cta">
            <button className="btn-main btn-primary" onClick={() => navigate("/events/party#party-formats")}>
              Dołącz do nas
            </button>
          </div>
        </div>
      </section>

      {/* TYPES */}
      <section id="types" className="section band band--magenta types">
        {/* Dekory w sekcji */}
        <span className="decor decor-blob a" aria-hidden="true" />
        <span className="decor decor-blob b" aria-hidden="true" />
        <span className="decor decor-spark s1" aria-hidden="true" />
        <span className="decor decor-spark s2" aria-hidden="true" />

        <div className="section-head">
          <h2>Baw się razem z nami</h2>
        </div>

        <div className="types-grid reveal">
          <div
            className="type-card"
            role="button"
            tabIndex={0}
            onClick={() => navigate("/events/party")}
            onKeyDown={(e) => onCardKey(e, "/events/party")}
            aria-label="Imprezy dla singli"
          >
            <img src="/images/single.jpg" alt="" className="type-img" loading="lazy" />
            <div className="type-gradient" />
            <div className="type-caption">
              <h3>Spotkania</h3>
              <div className="type-btn btn btn-primary">Dowiedz się więcej</div>
            </div>
          </div>

          <div
            className="type-card"
            role="button"
            tabIndex={0}
            onClick={() => navigate("/events/girlsmeetings")}
            onKeyDown={(e) => onCardKey(e, "/events/girlsmeetings")}
            aria-label="Warsztaty dla kobiet"
          >
            <img src="/images/workshop.jpg" alt="" className="type-img" loading="lazy" />
            <div className="type-gradient" />
            <div className="type-caption">
              <h3>Spotkania dla kobiet</h3>
              <div className="type-btn btn btn-primary">Dowiedz się więcej</div>
            </div>
          </div>
        </div>
      </section>

      {/* CROSS-SECTION BLOB + WAVE: między TYPES a JOIN */}
      <div className="wave-sep" aria-hidden="true">
        <svg viewBox="0 0 1440 120" preserveAspectRatio="none" className="wave-svg">
          <path d="M0,64 C120,96 240,128 360,128 C480,128 600,96 720,80 C840,64 960,64 1080,80 C1200,96 1320,128 1440,140 L1440,0 L0,0Z" />
        </svg>
      </div>

      {/* JOIN */}
      <section id="join" className="section band band--white join">
        <div className="join-text reveal">
          <h2>Jak do nas dołączyć</h2>

    <ol className="steps">
      <li>
        <div className="step-content">
          <strong className="step-title">
            Wybierz rodzaj spotkania
          </strong>

          <p className="step-desc">
            Kolacja w kameralnym gronie, spotkanie przy winie
            czy większy Someet Social — wybierz to, na co masz ochotę.
          </p>
        </div>
      </li>

      <li>
        <div className="step-content">
          <strong className="step-title">
            Wybierz miasto i zapisz się na listę
          </strong>

          <p className="step-desc">
            Daj nam znać, gdzie chcesz dołączyć.
            Zapis na listę jest bezpłatny i do niczego Cię nie zobowiązuje.
          </p>
        </div>
      </li>

      <li>
        <div className="step-content">
          <strong className="step-title">
            Poczekaj na zaproszenie
          </strong>

          <p className="step-desc">
            Gdy zbierzemy odpowiednią grupę, odezwiemy się
            z propozycją terminu, miejsca i wszystkimi szczegółami.
          </p>
        </div>
      </li>
    </ol>
          <div className="split-cta">
            <button className="btn btn-primary" onClick={() => navigate("/registration")}>Dołącz teraz</button>
            <button className="btn btn-outline" onClick={() => navigate("/events")}>Zobacz wszystkie spotkania</button>
          </div>
        </div>

        <div className="join-visual reveal">
          <div className="join-collage">
            <img className="join-img join-img-a" src="/images/party2.jpg" alt="Klimat imprezy" />
            <img className="join-img join-img-b" src="/images/orange-cocktails.jpg" alt="Klimat warsztatów" />
          </div>
        </div>
      </section>

      {/* WAVE (odwrócona) + CROSS-SECTION BLOB: między JOIN a UPCOMING */}
      <div className="wave-sep flip" aria-hidden="true">
        <svg viewBox="0 0 1440 120" preserveAspectRatio="none" className="wave-svg">
          <path d="M0,64 C120,96 240,128 360,128 C480,128 600,96 720,80 C840,64 960,64 1080,80 C1200,96 1320,128 1440,140 L1440,0 L0,0Z" />
        </svg>
      </div>
      <span className="bleed-blob" aria-hidden="true" />

      {/* UPCOMING */}
      {/* UPCOMING */}
<section
  id="upcoming"
  className="section band band--sand upcoming"
>
  <div className="section-head">
    <h2>Na jakie spotkanie masz ochotę?</h2>

    <p className="upcoming-subtitle">
        Zapisz się na listę zainteresowanych. Wybierz format i miasto. 
        Kiedy zbierzemy grupę, odezwiemy się do Ciebie z propozycją terminu i wszystkimi szczegółami.
    </p>
  </div>

  <div className="upcoming-grid">

    {/* KOLACJA */}
    <article className="event-card reveal">
      <img
        src="/imagesEvents/dinner1.jpg"
        alt="Kolacja w kameralnym gronie"
        className="event-img"
        loading="lazy"
      />

      <div className="event-body">
        <h3 className="event-title">
          Kolacja w kameralnym gronie
        </h3>

        <p className="event-description">
          Kameralne spotkanie przy wspólnym stole,
          stworzone po to, żeby poznawać nowych ludzi.
        </p>

        <div className="chips">
          <span className="chip">
            📍 Wybierz miasto
          </span>
        </div>

        <div className="event-actions">
          <button
            type="button"
            className="btn btn-primary"
            onClick={() =>
              navigate("/events/party/dinner")
            }
          >
            Chcę dołączyć
          </button>
        </div>
      </div>
    </article>


    {/* WINO */}
    <article className="event-card reveal">
      <img
        src="/images/party4.jpg"
        alt="Spotkanie przy winie"
        className="event-img"
        loading="lazy"
      />

      <div className="event-body">
        <h3 className="event-title">
          Spotkanie przy winie
        </h3>

        <p className="event-description">
      Wieczór przy winie i rozmowach w swobodnej atmosferze. 
      Przyjdź poznać nowych ludzi i spędzić czas trochę inaczej niż zwykle.

        </p>

        <div className="chips">
          <span className="chip">
            📍 Wybierz miasto
          </span>
        </div>

        <div className="event-actions">
          <button
            type="button"
            className="btn btn-primary"
            onClick={() =>
              navigate("/events/party/wine")
            }
          >
            Chcę dołączyć
          </button>
        </div>
      </div>
    </article>


    {/* SOMEET SOCIAL */}
    <article className="event-card reveal">
      <img
        src="/images/party2.jpg"
        alt="Someet Social"
        className="event-img"
        loading="lazy"
      />

      <div className="event-body">
        <h3 className="event-title">
          Someet Social
        </h3>

        <p className="event-description">
          Większe spotkanie z muzyką
          i przestrzenią do poznawania nowych osób.
        </p>

        <div className="chips">
          <span className="chip">
            📍 Wybierz miasto
          </span>
        </div>

        <div className="event-actions">
          <button
            type="button"
            className="btn btn-primary"
            onClick={() =>
              navigate("/events/party/social")
            }
          >
            Chcę dołączyć
          </button>
        </div>
      </div>
    </article>

  </div>
</section>
    </div>
  );
}